import { inject, Injectable, Injector } from '@angular/core';

import { BitfAppSessionService } from '@bitf/services/app-session/bitf-app-session.service';
import { BitfTagManagerService } from '@bitf/services/tag-manager/bitf-tag-manager.service';
import { BitfLogDnaSenderService } from '@bitf/services/logger/bitf-log-dna-sender.service';
import { BitfPwaService } from '@bitf/services/pwa/bitf-pwa.service';
import { ResponsiveService } from '@services';
import { MaterialIconRegistryService } from './material-icon-registry.service';

@Injectable({
  providedIn: 'root',
})
export class AppSessionService extends BitfAppSessionService {
  bitfLogDnaSenderService = inject(BitfLogDnaSenderService);
  bitfTagManagerService = inject(BitfTagManagerService);
  private responsiveService = inject(ResponsiveService);
  protected bitfPwaService = inject(BitfPwaService);
  protected materialIconRegistryService = inject(MaterialIconRegistryService);

  constructor(injector: Injector = inject(Injector)) {
    super(injector);
  }

  async init() {
    await super.init();
    // NOTE: At this point translations are already loaded

    this.initBreakpointListener();
    this.responsiveService.init();

    this.bitfLogDnaSenderService.init();

    this.bitfPwaService.initOnlineChecker();
    this.bitfPwaService.showDefaultOnlineStateChangeToast();
  }

  initLogSender() {
    console.log('initLogSender, Implement me');
  }
}
